import {HiddenProductPayloadDto} from '@features/product/application/use_cases/hidden-product/dto/hidden-product.payload.dto';
import {HiddenProductResponseDto} from '@features/product/application/use_cases/hidden-product/dto/hidden-product.response.dto';
import {HiddenProductHttpPayloadDto} from '@features/product/infrastructure/http/hidden-product/hidden-product.http.payload.dto';
import {HiddenProductHttpResponseDto} from '@features/product/infrastructure/http/hidden-product/hidden-product.http.response.dto';

export class HiddenProductHttpMapper {

  static toResponse(data: HiddenProductHttpResponseDto): HiddenProductResponseDto {
    return {};
  }

  static toInfra(data: HiddenProductPayloadDto): HiddenProductHttpPayloadDto {
    return {};
  }

}
